import { OrderEntryPath } from '@models/order';
import { orderActions } from '@store/order/orderSlice';
import { RootState } from '@store/store';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function useCopyRequest(path?: OrderEntryPath, itemActivityId?: string) {
    const dispatch = useDispatch();
    const itemRequest = useSelector(
        (root: RootState) => (
            itemActivityId ? root.item[itemActivityId] : undefined
        ),
    );
    const cartRequest = useSelector((root: RootState) => root.cart);
    useEffect(() => {
        if (path === 'direct' && itemRequest) {
            dispatch(orderActions.copy(itemRequest));
        } else if (path === 'cart') {
            dispatch(orderActions.copy(cartRequest));
        }
    }, []);
}

export default useCopyRequest;
